import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const AuditFilters = ({ filters, onFilterChange, onReset, onExport }) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'thismonth', label: 'This Month' },
    { value: 'lastmonth', label: 'Last Month' }
  ];

  const userOptions = [
    { value: 'all', label: 'All Users' },
    { value: 'user-001', label: 'John Doe (Admin)' },
    { value: 'user-002', label: 'Jane Smith (Analyst)' },
    { value: 'user-003', label: 'Mike Johnson (Merchant)' },
    { value: 'user-004', label: 'Sarah Williams (Analyst)' }
  ];

  const actionTypeOptions = [
    { value: 'all', label: 'All Actions' },
    { value: 'authentication', label: 'Authentication' },
    { value: 'dataaccess', label: 'Data Access' },
    { value: 'configuration', label: 'Configuration Changes' },
    { value: 'export', label: 'Export Activities' },
    { value: 'usermanagement', label: 'User Management' }
  ];

  const riskLevelOptions = [
    { value: 'all', label: 'All Risk Levels' },
    { value: 'low', label: 'Low Risk' },
    { value: 'medium', label: 'Medium Risk' },
    { value: 'high', label: 'High Risk' }
  ];

  const exportFormatOptions = [
    { value: 'csv', label: 'CSV' },
    { value: 'json', label: 'JSON' },
    { value: 'pdf', label: 'PDF' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg md:text-xl font-semibold text-foreground">
            Audit Filters
          </h3>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            onClick={() => onExport?.('csv')}
          >
            Export
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="RotateCcw"
            onClick={onReset}
          >
            Reset
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange?.('dateRange', value)}
        />

        <Select
          label="User"
          options={userOptions}
          value={filters?.user}
          onChange={(value) => onFilterChange?.('user', value)}
          searchable
        />

        <Select
          label="Action Type"
          options={actionTypeOptions}
          value={filters?.actionType}
          onChange={(value) => onFilterChange?.('actionType', value)}
        />

        <Select
          label="Risk Level"
          options={riskLevelOptions}
          value={filters?.riskLevel}
          onChange={(value) => onFilterChange?.('riskLevel', value)}
        />
      </div>

      {/* Active Filters Display */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex flex-wrap gap-2">
          {Object.entries(filters)?.map(([key, value]) => {
            if (value === 'all' || !value) return null;
            return (
              <div
                key={key}
                className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-lg text-xs md:text-sm"
              >
                <span className="font-medium capitalize">
                  {key?.replace(/([A-Z])/g, ' $1')?.trim()}:
                </span>
                <span>{value}</span>
                <button
                  onClick={() => onFilterChange?.(key, 'all')}
                  className="ml-1 hover:bg-primary/20 rounded-full p-0.5 transition-colors"
                >
                  <Icon name="X" size={12} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AuditFilters;